import _ from "lodash";
import { applyOpacityToColor, isValuePresent } from "../../utils/builderUtils";

export const buildFormStylesheet = (builder, device, cta, element, variant) => {
    let options = { ...element.options };

    let fieldRadius;
    if (options["field-rounded"] == "cf-field-not-rounded") {
      fieldRadius = "0px";
    }
    if (options["field-rounded"] == "cf-field-slightly-rounded") {
      fieldRadius = "3px";
    }
    if (options["field-rounded"] == "cf-field-fully-rounded") {
      fieldRadius = "100px";
    }
    if (options["field-rounded"] == "custom") {
      fieldRadius = "";
      ["top-left", "top-right", "bottom-right", "bottom-left"].forEach(
        (side) => {
          fieldRadius += `${
            _.isNil(options["field-radius-" + side]) == false
              ? options["field-radius-" + side]
              : "3"
          }px `;
        }
      );
    }

    let fieldFontSize;
    if (options["field-font-size"]) {
      fieldFontSize = options["field-font-size"];
    }

    let fieldLabelFontSize;
    if (options["field-label-font-size"]) {
      fieldLabelFontSize = options["field-label-font-size"];
    }

    let fieldConsentLabelFontSize;
    if (options["field-consent-label-font-size"]) {
      fieldConsentLabelFontSize = options["field-consent-label-font-size"];
    }

    let fieldSmsConsentLabelFontSize;
    if (options["field-sms-consent-label-font-size"]) {
      fieldSmsConsentLabelFontSize = options["field-sms-consent-label-font-size"];
    }

    let fieldLabelFontFamily;
    if (options["field-label-font-family"]) {
      fieldLabelFontFamily = options["field-label-font-family"];
    }

    let fontWeight;
    if (
      options["field-font-weight"] &&
      options["field-font-weight"] !== "theme"
    ) {
      fontWeight = options["field-font-weight"];
    }

    let fieldLabelFontWeight;
    if (options["field-label-font-weight"]) {
      fieldLabelFontWeight = options["field-label-font-weight"];
    }

    let boxShadow;

    if (options["box-shadow"] == "soft") {
      boxShadow = "0 5px 15px 0 rgb(179 179 179 / 78%)";
    }

    if (options["box-shadow"] == "hard") {
      boxShadow = "-5px 5px 0 0 rgb(0 0 0 / 10%)";
    }

    if (options["box-shadow"] == "custom") {
      boxShadow = "";
      boxShadow +=
        (element.options["box-shadow-horizontal-distance"]
          ? `${element.options["box-shadow-horizontal-distance"]}px`
          : "0px") + " ";

      boxShadow +=
        (element.options["box-shadow-vertical-distance"]
          ? `${element.options["box-shadow-vertical-distance"]}px`
          : "0px") + " ";

      boxShadow +=
        (element.options["box-shadow-blur-radius"]
          ? `${element.options["box-shadow-blur-radius"]}px`
          : "0px") + " ";

      boxShadow +=
        (element.options["box-shadow-spread-radius"]
          ? `${element.options["box-shadow-spread-radius"]}px`
          : "0px") + " ";

      boxShadow +=
        (element.options["box-shadow-color"]
          ? element.options["box-shadow-color"]
          : "rgba(0,0,0, 0.35)") + " ";
    }

    // prettier-ignore
    let handleStyle = `
      ${options['field-handle-color'] ? 'background: ' + options['field-handle-color'] + ';' : ''} 
      ${options['field-handle-border-color'] ? 'border-color: ' + options['field-handle-border-color'] + ';' : ''}`

    // source: app/views/cta/_css.html.erb:2026
    let regularInputPadding = {
      top: 11,
      right: 0,
      bottom: 9,
      left: 10,
    };

    // source: app/views/cta/_css.html.erb:2074
    let largeInputPadding = {
      top: 12,
      right: 0,
      bottom: 10,
      left: 10,
    };

    // line-height has been deprecated from CF input forms due to incompatibility with select fields. This is a formula
    // to keep the same old looking but using padding.
    // Multiplies the fontSize for 1.5 bc it is the old line-height value for inputs ( now it's replace for this padding )
    let consideredFontSize =
      fieldFontSize || variant.options["field-font-size"] || 15;
    let inputPaddingFormula = Math.floor((consideredFontSize * 1.5) / 4 / 2);

    // prettier-ignore
    let regularInputPaddingCalculated = `${regularInputPadding["top"] + inputPaddingFormula}px
      ${regularInputPadding["right"]}px
      ${regularInputPadding["bottom"] + inputPaddingFormula}px
      ${regularInputPadding["left"]}px`;

    // prettier-ignore
    let largeInputPaddingCalculated = `${largeInputPadding["top"] + inputPaddingFormula}px
      ${largeInputPadding["right"]}px
      ${largeInputPadding["bottom"] + inputPaddingFormula}px
      ${largeInputPadding["left"]}px`;

    let intFieldSizeValue = parseInt(options["field-size-value"]);
    // prettier-ignore
    let customInputPaddingCalculated = `${intFieldSizeValue + inputPaddingFormula}px
      ${intFieldSizeValue}px
      ${intFieldSizeValue + inputPaddingFormula}px
      ${intFieldSizeValue}px`;

    let formWidth = "";
    if (options["form-width"] && options["form-width"] == "custom") {
      formWidth = `${options["form-width-value"]}px`;
    }

    let formHorizontalAlignment = '';
    switch (options["cf-alignment"]) {
      case "cf-outer-left":
        formHorizontalAlignment = 'left';
        break;
      case "cf-outer-center":
        formHorizontalAlignment = 'center';
        break;
      case "cf-outer-right":
        formHorizontalAlignment = 'right';
        break;
      default:
        formHorizontalAlignment = 'center';
        break;
    }

    const formFieldsPerRow = options["form-fields-per-row"] || 4;
    const horizontalFormFlex = `flex: 1 0 ${(80 / formFieldsPerRow).toFixed(2)}% !important;`;

    const buttonHorizontalAlignment = options["form-horizontal-button-alignment"] || "end";

    // prettier-ignore
    let desktopStyles =
`#cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-form-2 {
  ${formWidth ? `max-width: ${formWidth};` : ''}
}

#cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-recaptcha-box {
  margin-top: 10px;
  margin-bottom: 10px;
}

#cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-form-2.cf-form-horizontal .cf-form-container {
  width: 100%;
  justify-content: ${formHorizontalAlignment};
  display: flex !important;
  gap: 10px;
  ${element.options["form-horizontal-button-placement"] == "below" ? `flex-direction: column; margin-bottom: 8px;` : ''}
}

#cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-form-2.cf-form-horizontal .cf-form-consent {
  margin-top: 10px;
  ${element.options["form-horizontal-button-placement"] == "below" ? `margin-bottom: 8px;` : ''}
}

#cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-form-2.cf-form-theme-default.cf-form-horizontal {
  overflow: hidden;
}

#cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-form-2.cf-form-horizontal .cf-button-inner {
  ${element.options["form-horizontal-button-placement"] == "below" ? `min-width: initial !important;` : ''}
  ${options["button-width"] == 'custom' && options["button-width-value"] ? 'width: ' + options["button-width-value"] + 'px !important;' : ''}
}

#cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-form-2.cf-form-horizontal .cf-form-button {
  ${element.options["form-horizontal-button-placement"] !== "below" ? `display: flex; align-items: ${buttonHorizontalAlignment === 'top' ? 'flex-start' : buttonHorizontalAlignment};` : ''}
  ${element.options["form-horizontal-button-placement"] == "below" ? `max-width: 100% !important; width: unset !important;` : ''}
}

#cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-form-2.cf-form-horizontal .cf-form-button .cf-button {
  ${element.options["form-horizontal-button-placement"] != "below" ? `min-width: 101% !important;` : ''}
}

#cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-form-2.cf-form-horizontal .cf-form-fields {
  ${options["form-width"] == "custom"? `width: ${formWidth} !important;` : ''}
  display: inline-flex !important;
  gap: 8px;
  align-items: end;
  ${formFieldsPerRow ? 'flex-wrap: wrap;' : 'flex-wrap: nowrap;'}
  ${element.options["form-horizontal-button-placement"] == "below" ? `width: 100% !important;` : ''}
}

#cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-form-2.cf-form-horizontal .cf-form-field {
  margin-right: unset !important;
  ${horizontalFormFlex ? horizontalFormFlex : ''}
}

#cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-form-2.cf-form-horizontal .cf-form-fields .cf-form-field.cf-consent-field {
  flex: 1 1 100% !important;
  width: 100% !important;
  max-width: 100% !important;
}

${options["form-vertical-button-alignment"] ? `
#cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-form-2:not(.cf-form-horizontal) .cf-button-outer {
  margin-left: ${{ left: "0px", center: "auto", right: "auto" }[options["form-vertical-button-alignment"]]} !important;
  margin-right: ${{ left: "auto", center: "auto", right: "0px" }[options["form-vertical-button-alignment"]]} !important;
}` : ''}

#cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-recaptcha-response-validation {
  opacity: 0;
  position: absolute !important;
  left: 0;
  z-index: -1;
}

#cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-form-2.cf-form-theme-default input[type="text"],
#cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-form-2.cf-form-theme-default input[type="date"],
#cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-form-2.cf-form-theme-default input[type="datetime-local"],
#cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-form-2.cf-form-theme-default input[type="email"],
#cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-form-2.cf-form-theme-default input[type="tel"],
#cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-form-2.cf-form-theme-default input[type="number"],
#cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-form-2.cf-form-theme-default textarea {
  ${_.isNil(options["field-text-color"]) == false ? 'color: ' + options["field-text-color"] + ' !important;' : ''}
}

#cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-form.element-content .cf-form-2.cf-form-theme-default select:not(.cf-sms-countries):not(select[data-selected="true"]) {
  ${isValuePresent(options["field-text-color"]) == true ? `color: ${applyOpacityToColor(options["field-text-color"], 50, false)} !important;` : ''}
}

#cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-form.element-content .cf-form-2.cf-form-theme-default select[data-selected="true"] {
  ${isValuePresent(options["field-text-color"]) == true ? `color: ${options["field-text-color"]} !important;` : ''}
}

#cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-form-2.cf-form-theme-default input[type="text"],
#cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-form-2.cf-form-theme-default input[type="date"],
#cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-form-2.cf-form-theme-default input[type="datetime-local"],
#cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-form-2.cf-form-theme-default input[type="email"],
#cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-form-2.cf-form-theme-default input[type="tel"],
#cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-form-2.cf-form-theme-default input[type="number"],
#cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-form-2.cf-form-theme-default textarea,
#cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-form-2.cf-form-theme-default select {
  ${_.isNil(options["field-background-color"]) == false ? 'background: ' + options["field-background-color"] + ' !important;' : ''}
  ${_.isNil(options["field-border-style"]) == false ? 'border-style: ' + options["field-border-style"] + ' !important;' : ''}
  ${_.isNil(options["field-border-width"]) == false ? 'border-width: ' + options["field-border-width"] + 'px !important;' : ''}
  ${_.isNil(options["field-border-width-left"]) == false ? 'border-left-width: ' + options["field-border-width-left"] + 'px !important;' : ''}
  ${_.isNil(options["field-border-width-right"]) == false ? 'border-right-width: ' + options["field-border-width-right"] + 'px !important;' : ''}
  ${_.isNil(options["field-border-width-top"]) == false ? 'border-top-width: ' + options["field-border-width-top"] + 'px !important;' : ''}
  ${_.isNil(options["field-border-width-bottom"]) == false ? 'border-bottom-width: ' + options["field-border-width-bottom"] + 'px !important;' : ''}
  ${_.isNil(options["field-border-color"]) == false ? 'border-color: ' + options["field-border-color"] + ' !important;' : ''}
  ${_.isNil(fieldRadius) == false ? 'border-radius: ' + fieldRadius + ' !important;' : ''}
  ${boxShadow ? 'box-shadow: ' + boxShadow + ' !important;' : ''}
  ${fontWeight ? `font-weight: ${fontWeight} !important;` : ''}
  ${options["field-size"] == 'custom' && _.isNil(options["field-size-value"]) == false ? `padding: ${customInputPaddingCalculated} !important; padding-right: 5px !important;` : `padding: ${regularInputPaddingCalculated} !important;`}
  ${fieldFontSize ? `font-size: ${fieldFontSize}px !important;` : ''}
  ${options["field-font"] ? `font-family: ${options["field-font"]}, sans-serif !important;` : ''}
}

#cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-form-2.cf-field-large input[type="text"],
#cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-form-2.cf-field-large input[type="email"],
#cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-form-2.cf-field-large input[type="tel"],
#cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-form-2.cf-field-large input[type="number"],
#cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-form-2.cf-field-large textarea,
#cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-form-2.cf-field-large select {
  ${options["field-size"] != 'custom' ? `padding: ${largeInputPaddingCalculated} !important;` : ''}
}

#cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-form-2 select.cf-sms-countries {
  ${consideredFontSize ? `font-size: ${consideredFontSize - 1}px !important;` : ''}
  padding-left: 10px !important;
  padding-right: 0px !important;
}

#cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-form-2.cf-form-theme-default .cf-label {
  ${options["label-color"] ? 'color: ' + options["label-color"] + ' !important;' : ''}
  ${fieldLabelFontSize ? `font-size: ${fieldLabelFontSize}px !important;` : ''}
  ${fieldLabelFontWeight ? `font-weight: ${fieldLabelFontWeight} !important;` : fontWeight ? `font-weight: ${fontWeight};` : ''}
  ${fieldLabelFontFamily ? `font-family: ${fieldLabelFontFamily} !important;` : options["field-font"] ? `font-family: ${options["field-font"]}, sans-serif !important;` : ''}
}

#cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-form-2.cf-form-theme-default .cf-consent-label {
  ${fieldLabelFontWeight ? `font-weight: ${fieldLabelFontWeight} !important;` : ''}
}

#cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-form-2.cf-form-theme-default .cf-consent-label:not(.cf-sms-label) {
  ${fieldConsentLabelFontSize ? `font-size: ${fieldConsentLabelFontSize}px !important;` : ''}
}

#cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-form-2.cf-form-theme-default .cf-sms-label {
  ${fieldSmsConsentLabelFontSize ? `font-size: ${fieldSmsConsentLabelFontSize}px !important;` : ''}
}

#cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-form-2.cf-form-theme-default .cf-field-range-slider {
  ${_.isNil(options["field-background-color"]) == false ? 'background: ' + options["field-background-color"] + ' !important;' : ''}
  ${_.isNil(options["field-border-style"]) == false ? 'border-style: ' + options["field-border-style"] + ' !important;' : ''}
  ${_.isNil(options["field-border-width"]) == false ? 'border-width: ' + options["field-border-width"] + 'px !important;' : ''}
  ${_.isNil(options["field-border-width-left"]) == false ? 'border-left-width: ' + options["field-border-width-left"] + 'px !important;' : ''}
  ${_.isNil(options["field-border-width-right"]) == false ? 'border-right-width: ' + options["field-border-width-right"] + 'px !important;' : ''}
  ${_.isNil(options["field-border-width-top"]) == false ? 'border-top-width: ' + options["field-border-width-top"] + 'px !important;' : ''}
  ${_.isNil(options["field-border-width-bottom"]) == false ? 'border-bottom-width: ' + options["field-border-width-bottom"] + 'px !important;' : ''}
  ${_.isNil(options["field-border-color"]) == false ? 'border-color: ' + options["field-border-color"] + ' !important;' : ''}
  ${_.isNil(fieldRadius) == false ? 'border-radius: ' + fieldRadius + ' !important;' : ''}
  ${boxShadow ? 'box-shadow: ' + boxShadow + ' !important;' : ''}
}

#cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-form-2.cf-form-theme-default .noUi-value {
  ${options["label-color"] ? 'color: ' + options["label-color"] + ';' : ''}
}

#cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-form-2.cf-form-theme-default .noUi-marker {
  ${options["label-color"] ? 'background: ' + options["label-color"] + ';' : ''};
}

#cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-form-2.cf-form-theme-default .noUi-connect {
  ${_.isNil(options["field-border-color"]) == false ? 'background: ' + options["field-border-color"] + ' !important;' : ''}
}

#cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-form-2.cf-form-theme-default .noUi-handle {
  ${handleStyle}
}

#cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-form-2.cf-form-theme-default .noUi-tooltip {
  ${_.isNil(options["field-text-color"]) == false ? 'color: ' + options["field-text-color"] + ' !important;' : ''}
}

#cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-form-2.cf-form-theme-default input[type="text"]::placeholder, 
#cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-form-2.cf-form-theme-default input[type="date"]::placeholder,
#cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-form-2.cf-form-theme-default input[type="datetime-local"]::placeholder,
#cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-form-2.cf-form-theme-default input[type="email"]::placeholder, 
#cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-form-2.cf-form-theme-default input[type="tel"]::placeholder,
#cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-form-2.cf-form-theme-default input[type="number"]::placeholder,
#cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-form-2.cf-form-theme-default textarea::placeholder, 
#cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-form-2.cf-form-theme-default select::placeholder {
  ${_.isNil(options["field-text-color"]) == false ? 'color: ' + options["field-text-color"] + ' !important;' : ''}
  ${fontWeight ? `font-weight: ${fontWeight} !important;` : ''}
}`;

    const preset_fields = ["name", "lastname", "email", "phone", "url", "company-name", "company-title", "city", "state", "country", "address", "zip-code"];
    preset_fields.forEach((field) => {
      const setting_only_field_on_row = element.options[field + "-only-on-row"] ? element.options[field + "-only-on-row"] : field == "phone" ? "true" : "false";
      const only_field_on_row = setting_only_field_on_row == "true";
      if (only_field_on_row && element.options["form-type"] == "horizontal") {
        desktopStyles += `
          #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-form-2.cf-form-horizontal .cf-form-field[data-field="${field}"] {
            flex: 1 0 100% !important;
          }
        `
      }
    })

    Object.values(element.fields).forEach((field) => {
      const only_field_on_row = field.options["only-on-row"] == "true";
      if (only_field_on_row && element.options["form-type"] == "horizontal") {
        desktopStyles += `
          #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-form-2.cf-form-horizontal .cf-form-field[data-id="${field.id}"] {
            flex: 1 0 100% !important;
          }
        `
      }
    })

    let fontSizeMobile;
    if (options["field-font-size-mobile"]) {
      fontSizeMobile = options["field-font-size-mobile"];
    }

    let fontLabelSizeMobile;
    if (options["field-label-font-size-mobile"]) {
      fontLabelSizeMobile = options["field-label-font-size-mobile"];
    }

    let fieldConsentLabelFontSizeMobile;
    if (options["field-consent-label-font-size-mobile"]) {
      fieldConsentLabelFontSizeMobile = options["field-consent-label-font-size-mobile"];
    }

    let fieldSmsConsentLabelFontSizeMobile;
    if (options["field-sms-consent-label-font-size-mobile"]) {
      fieldSmsConsentLabelFontSizeMobile = options["field-sms-consent-label-font-size-mobile"];
    }

    let consideredFontSizeMobile =
      fontSizeMobile ||
      fieldFontSize ||
      variant.options["field-font-size-mobile"] ||
      variant.options["field-font-size"] ||
      15;

    let formWidthMobile = "";
    if (options["form-width-mobile"] == 'cf-form-small' || !options["form-width-mobile"] && options["form-width"] == 'cf-form-small') {
      formWidthMobile = "375px";
    } else if (options["form-width-mobile"] == 'cf-form-mid' || !options["form-width-mobile"] && options["form-width"] == 'cf-form-mid') {
      formWidthMobile = "450px";
    } else if (options["form-width-mobile"] == "custom" && options["form-width-value-mobile"]) {
      formWidthMobile = `${options["form-width-value-mobile"]}px`;
    }

    const formFieldsPerRowMobile = options["form-fields-per-row-mobile"]
      ? options["form-fields-per-row-mobile"]
      : options["form-fields-per-row"]
      ? options["form-fields-per-row"]
      : 4;
    const horizontalFormFlexMobile = `flex: 1 0 ${(80 / formFieldsPerRowMobile).toFixed(2)}% !important;`;

    const buttonPlacementMobile =
      element.options["form-horizontal-button-placement-mobile"] ||
      (element.options["form-horizontal-button-placement"] == "below"
        ? "below"
        : "inline");

    const buttonHorizontalAlignmentMobile =
      options["form-horizontal-button-alignment-mobile"] ||
      buttonHorizontalAlignment;

    // prettier-ignore
    let mobileStyles =
    `/* mobile styles */
    #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-form-2.cf-form-theme-default input[type="text"],
    #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-form-2.cf-form-theme-default input[type="date"],
    #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-form-2.cf-form-theme-default input[type="datetime-local"],
    #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-form-2.cf-form-theme-default input[type="email"],
    #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-form-2.cf-form-theme-default input[type="tel"],
    #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-form-2.cf-form-theme-default input[type="number"],
    #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-form-2.cf-form-theme-default textarea,
    #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-form-2.cf-form-theme-default select {
      ${fontSizeMobile ? `font-size: ${fontSizeMobile}px !important;` : ''}
    }

    #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-form-2.cf-form-horizontal .cf-button-inner {
      ${options["button-width-mobile"] == 'custom' && options["button-width-value-mobile"] ? 'width: ' + options["button-width-value-mobile"] + 'px !important;' : ''}
    }

    #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-form-2.cf-form-horizontal .cf-form-fields {
      ${formFieldsPerRowMobile ? 'flex-wrap: wrap !important;' : 'flex-wrap: nowrap !important;'}
    }

    #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-form-2.cf-form-horizontal .cf-form-field {
      ${horizontalFormFlexMobile ? horizontalFormFlexMobile : ''}
    }

    #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-form-2 {
      ${formWidthMobile ? `max-width: ${formWidthMobile} !important;` : ''}
    }

    #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-form-2 select.cf-sms-countries {
      ${consideredFontSizeMobile ? `font-size: ${consideredFontSizeMobile - 2}px !important;` : ''}
    }

    #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-form-2.cf-form-theme-default .cf-label {
      ${fontLabelSizeMobile ? `font-size: ${fontLabelSizeMobile}px !important;` : ''}
    }

    #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-form-2.cf-form-theme-default .cf-consent-label:not(.cf-sms-label) {
      ${fieldConsentLabelFontSizeMobile ? `font-size: ${fieldConsentLabelFontSizeMobile}px !important;` : ''}
    }

    #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-form-2.cf-form-theme-default .cf-sms-label {
      ${fieldSmsConsentLabelFontSizeMobile ? `font-size: ${fieldSmsConsentLabelFontSizeMobile}px !important;` : ''}
    }

    #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-form-2.cf-form-horizontal .cf-form-container {
      ${buttonPlacementMobile == "below" ? `flex-direction: column; margin-bottom: 8px;` : 'flex-direction: row;'}
    }

    #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-form-2.cf-form-horizontal .cf-form-consent {
      ${buttonPlacementMobile == "below" ? `margin-bottom: 8px;` : ''}
    }

    #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-form-2.cf-form-horizontal .cf-button-inner {
      ${buttonPlacementMobile == "below" ? `min-width: initial !important;` : ''}
    }

    #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-form-2.cf-form-horizontal .cf-form-button {
      ${buttonPlacementMobile == "inline" ? `display: flex; align-items: ${buttonHorizontalAlignmentMobile === 'top' ? 'flex-start' : buttonHorizontalAlignmentMobile};` : ''}
      ${buttonPlacementMobile == "below" ? `max-width: 100% !important; width: unset !important;` : ''}
    }

    #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-form-2.cf-form-horizontal .cf-form-button .cf-button {
      ${buttonPlacementMobile == "inline" ? `min-width: 101% !important;` : ''}
    }

    #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-form-2.cf-form-horizontal .cf-form-fields {
      ${buttonPlacementMobile == "below" ? `width: 100% !important;` : ''}
    }

    ${(options["form-vertical-button-alignment-mobile"] || options["form-vertical-button-alignment"]) ? (() => {
      const mobileAlign = options["form-vertical-button-alignment-mobile"] || options["form-vertical-button-alignment"];
      return `
    #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-form-2:not(.cf-form-horizontal) .cf-button-outer {
      margin-left: ${{ left: "0px", center: "auto", right: "auto" }[mobileAlign]} !important;
      margin-right: ${{ left: "auto", center: "auto", right: "0px" }[mobileAlign]} !important;
    }`;
    })() : ''}

    ${options["button-alignment-mobile"] ? (() => {
      const mobileBtnAlign = options["button-alignment-mobile"];
      const marginMap = {
        "cf-outer-left": { left: "0px", right: "auto" },
        "cf-outer-center": { left: "auto", right: "auto" },
        "cf-outer-right": { left: "auto", right: "0px" },
      };
      const margins = marginMap[mobileBtnAlign];
      if (!margins) return '';
      return `
    #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-form-2.cf-form-horizontal .cf-button-outer {
      margin-left: ${margins.left} !important;
      margin-right: ${margins.right} !important;
    }`;
    })() : ''}
    `;

    preset_fields.forEach((field) => {
      const setting_only_field_on_row = element.options[field + "-only-on-row"] ? element.options[field + "-only-on-row"] : field == "phone" ? "true" : "false";
      const only_field_on_row = setting_only_field_on_row == "true";
      if (only_field_on_row && element.options["form-type-mobile"] == "horizontal") {
        mobileStyles += `
          #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-form-2.cf-form-horizontal .cf-form-field[data-field="${field}"] {
            flex: 1 0 100% !important;
          }
        `
      }
    })

    Object.values(element.fields).forEach((field) => {
      const only_field_on_row = field.options["only-on-row"] == "true";
      if (only_field_on_row && element.options["form-type-mobile"] == "horizontal") {
        mobileStyles += `
          #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-form-2.cf-form-horizontal .cf-form-field[data-id="${field.id}"] {
            flex: 1 0 100% !important;
          }
        `
      }
    })

    if (builder !== true) {
      return desktopStyles + "@media (max-width: 599px) {" + mobileStyles + "}";
    } else {
      if (device == "desktop") {
        return desktopStyles;
      } else {
        return desktopStyles + mobileStyles;
      }
    }
};
